module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/cookies-45045ad9679a05d26b929936dd80ef03.svg";